import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleOpeNivel1 = props => {
  return (
    <option dato1={props.elemento.cedula} dato2={props.elemento.ciudad?props.elemento.ciudad:""} dato3={props.elemento.email?props.elemento.email:""} dato4={props.elemento.telefono?props.elemento.telefono:""} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaCom = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel4Detalle = list.map((elemento, _id) => <DetalleOpeNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="comercialAtiende" id="miLista" value={permiteUpdate?argsDocum.comercialAtiende:idLista.comercialAtiende} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {/* <option value="">Seleccionar...</option> */}
        {Nivel4Detalle}
      </select>
    </div>
  )
};

const ListaPais = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="pais" id="miLista1" value={permiteUpdate?argsDocum.pais:idLista.pais} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>Colombia</option>
        <option>Panamá</option>
      </select>
    </div>
  )
};

const ListaRu = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="rutas" id="miLista2" value={permiteUpdate?argsDocum.rutas?argsDocum.rutas:"No":idLista.rutas?idLista.rutas:"No"} onChange={(ev)=>handleChange(ev)}>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
  )
};

const ListaAn = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="anexos" id="miLista3" value={permiteUpdate?argsDocum.anexos?argsDocum.anexos:"No":idLista.anexos?idLista.anexos:"No"} onChange={(ev)=>handleChange(ev)}>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
  )
};

class VerEmpresa2 extends React.Component {
  state={
    argsDocum: {
      descrEmpresa: this.props.idLista.descrEmpresa,
      nit: this.props.idLista.nit?this.props.idLista.nit:"",
      pais: this.props.idLista.pais?this.props.idLista.pais:"",
      codEmpresa: this.props.idLista.codEmpresa?this.props.idLista.codEmpresa:"",
      comercialAtiende: this.props.idLista.comercialAtiende?this.props.idLista.comercialAtiende:'',
      direccion: this.props.idLista.direccion?this.props.idLista.direccion:"",
      telefono: this.props.idLista.telefono?this.props.idLista.telefono:"",
      logo: this.props.idLista.logo?this.props.idLista.logo:"",
      rutaLogo: this.props.idLista.rutaLogo?this.props.idLista.rutaLogo:"",
      file: "",
      rut: this.props.idLista.rut?this.props.idLista.rut:"",
      file1: "",
      camara: this.props.idLista.camara?this.props.idLista.camara:"",
      rutas: this.props.idLista.rutas?this.props.idLista.rutas:"N",
      anexos: this.props.idLista.anexos?this.props.idLista.anexos:"N",
      file2: "",
      _id: this.props.idLista._id
    },
    confirmaAct: false,
    open: false
  }

  // state={argsAdd: {}}

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
console.log(argsDocum)
      if(ev.target.name==='file' || ev.target.name==='file1' || ev.target.name==='file2' || ev.target.name==='rutas' || ev.target.name==='anexos'){
        let file = "", file1 = "", file2 = "", logo = "", rut = "", camara = ""

        if(ev.target.name==='file'){
          file = ev.target.files[0]
          logo = ev.target.files[0].name
          argsDocum['logo'] = logo
          argsDocum['file'] = file
        }else{
          if(ev.target.name==='file1'){
            file1 = ev.target.files[0]
            rut = ev.target.files[0].name
            argsDocum['rut'] = rut
            argsDocum['file1'] = file1
          }else{
            if(ev.target.name==='file2'){
              file2 = ev.target.files[0]
              camara = ev.target.files[0].name
              argsDocum['camara'] = camara
              argsDocum['file2'] = file2
            }else{
              if(ev.target.name === "rutas"){
                var miLista = document.getElementById("miLista2");
                argsDocum['rutas'] = miLista.options[miLista.selectedIndex].text
              }else{
                var miLista = document.getElementById("miLista3");
                argsDocum['anexos'] = miLista.options[miLista.selectedIndex].text
              }
            }  
          }        
        }

      }else{
        argsDocum[ev.target.name] = ev.target.value
      }
      this.setState({argsDocum})

    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click() 
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;
    let descrEmpresaAnt = this.props.idLista.descrEmpresa
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

// console.log(this.props.idLista.descrEmpresa)
console.log(argsDocum)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Empresa
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum, descrEmpresaAnt):()=>{}}>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '15%'}}>   
                  <Form.Field>
                    <label style={this.props.styles.label}>País</label>
                    <ListaPais styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                  
                </div>
                <div className="column" width="55%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrEmpresa" id="descrEmpresa" value={this.props.permiteUpdate?argsDocum.descrEmpresa:this.props.idLista.descrEmpresa} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrEmpresa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" width="15%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Nit</label>
                    <Form.Input autoComplete="off" name="nit" id="nit" value={argsDocum.nit} onChange={this.handleChange} placeholder='NIT' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nit'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" width="15%">
                  <Form.Field>
                      <label style={this.props.styles.label}>Código</label>
                      <Form.Input autoComplete="off" name="codEmpresa" id="codEmpresa" value={argsDocum.codEmpresa} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codEmpresa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> 
                </div>
              </div>
              <div className="row container">
                <div className="column" style={{width: '25%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Comercial que atiende</label>
                    <ListaCom list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>    
                </div>
                <div className="column" width="25%">
                  <Form.Field>
                      <label style={this.props.styles.label}>Dirección</label>
                      <Form.Input autoComplete="off" name="direccion" id="direccion" value={argsDocum.direccion} onChange={this.handleChange} placeholder='Dirección' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'direccion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" width="10%">
                  <Form.Field>
                      <label style={this.props.styles.label}>Teléfono</label>
                      <Form.Input autoComplete="off" name="telefono" id="telefono" value={argsDocum.telefono} onChange={this.handleChange} placeholder='Teléfono' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" width="40%">
                  <Form.Field>
                      <label style={this.props.styles.label}>URL del logo</label>
                      <Form.Input autoComplete="off" name="rutaLogo" id="rutaLogo" value={argsDocum.rutaLogo} onChange={this.handleChange} placeholder='URL del logo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'rutaLogo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              </div>
              <div className="row container">
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar logo...&nbsp;&nbsp;
                    </label>
                    <input id="file" name="file" type="file" accept="image/*" style={estilos} onChange={this.handleChange}></input>
                  </Form.Field>
                </div>
                <div className="column" width="25%">
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Archivo RUT...&nbsp;&nbsp;
                    </label>
                    <input id="file1" name="file1" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={this.handleChange}></input>
                  </Form.Field>  
                </div>
                <div className="column" width="25%">
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Archivo camara de cio...&nbsp;&nbsp;
                    </label>
                    <input id="file2" name="file2" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={this.handleChange}></input>
                  </Form.Field>  
                </div>
                <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Rutas</label>
                      <ListaRu styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
                <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={this.props.styles.label}>Anexos</label>
                      <ListaAn styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                </div>
              </div>
            </div>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              </div>
            </div>

                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

            
          </Form>
        </div>
      </div>
    )
  }
}

export default VerEmpresa2
